import { sendTransactions } from './sendTransactions';
export const signAndSendTransactions = async ({ transactions, walletAndConnection, minContextSlot, options, }) => {
    const { connection, wallet } = walletAndConnection;
    //? Use signTransaction method if signAllTransactions not supported or chunk size is 1
    if (!wallet.signAllTransactions || transactions.length === 1) {
        const signedTransaction = await wallet.signTransaction(transactions[0]);
        return await sendTransactions({
            transactions: [signedTransaction],
            connection: connection,
            minContextSlot,
            options,
        });
    }
    const signedTxns = await wallet.signAllTransactions(transactions);
    const signatureAndResendAbortController = await sendTransactions({
        transactions: signedTxns,
        connection: connection,
        minContextSlot,
        options,
    });
    return signatureAndResendAbortController;
};
